export default __webpack_public_path__ + "static/media/about_icon1hover.86e7be50.svg";